// src/services/api.js
import axios from "axios";

// Force an absolute URL fallback if environment variables are not loaded
const host =
  process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== "undefined"
    ? process.env.REACT_APP_API_URL
    : "http://10.5.21.42:5000";

// Strip trailing slashes and attach /api
const cleanHost = host.replace(/\/+$/, "");
const baseURL = cleanHost.endsWith("/api") ? cleanHost : `${cleanHost}/api`;

const api = axios.create({
  baseURL, // Guarantees 'http://10.5.21.42:5000/api'
  withCredentials: true,
});

console.log(process.env.REACT_APP_API_URL);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes("/login")
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;

// // src/services/api.js
// import axios from "axios";

// // Get base host from .env or fallback
// const host = process.env.REACT_APP_API_URL || "http://10.5.21.42:5000";

// // Ensure /api is appended if it's missing from the env variable
// const baseURL = host.endsWith("/api") ? host : `${host}/api`;

// const api = axios.create({
//   baseURL, // Resolves to http://10.5.21.42:5000/api
//   withCredentials: true,
// });

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (
//       error.response?.status === 401 &&
//       !window.location.pathname.includes("/login")
//     ) {
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   },
// );

// export default api;

// // // src/services/api.js
// // import axios from "axios";

// // const api = axios.create({
// //   baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
// //   withCredentials: true, // Transmits HTTP-only JWT cookies to Express
// // });

// // export default api;
